import React from 'react'
import noop from 'lib/function/noop'
import LuxkitModalBehaviourState, { LuxkitModalBehaviourDispatchAction, MODAL_BEHAVIOUR_INITIAL_STATE } from './LuxkitModalBehaviourState'

export const LuxkitModalBehaviourStateContext = React.createContext<LuxkitModalBehaviourState>(MODAL_BEHAVIOUR_INITIAL_STATE)
export const LuxkitModalBehaviourDispatchContext = React.createContext<React.Dispatch<LuxkitModalBehaviourDispatchAction>>(noop)
